/** @format */

import React from "react";
import Bdm from "./Bdm";
import Qqr from "./Qqr";
import Abmk from "./Abmk";
import Xorazm from "./Xorazm";
import Buxoro from "./Buxoro";
import Jizzax from "./Jizzax";
import Navoiy from "./Navoiy";
import Fargona from "./Fargona";
import Andijon from "./Andijon";
import Namangan from "./Namangan";
import Sirdaryo from "./Sirdaryo";
import Toshkent from "./Toshkent";
import Samarqand from "./Samarqand";
import Qashqadaryo from "./Qashqadaryo";
import Surxondaryo from "./Surxondaryo";
import BoshSahifa from "./dispatch/BoshSahifa";
import { exit } from "../../../../components/functions/Exit";

const regionComponents = {
  1: Qqr,
  2: Andijon,
  3: Buxoro,
  4: Jizzax,
  5: Qashqadaryo,
  6: Navoiy,
  7: Namangan,
  8: Samarqand,
  9: Sirdaryo,
  10: Surxondaryo,
  11: Toshkent,
  12: Fargona,
  13: Xorazm,
  14: Abmk,
  15: Bdm,
  16: BoshSahifa,
  17: BoshSahifa,
};

function Dashboard({ regionId, date }) {
  const RegionComponent = regionComponents[regionId];
  if (RegionComponent) {
    return <RegionComponent date={date} />;
  }
  exit();
  return null;
}

export default Dashboard;
